module.exports = __webpack_public_path__ + "static/media/image028.b343eca5.jpg";